import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as React from 'react';
import { Form } from 'antd';
import ClearErrors from '../clear_errors/ClearErrors';

const OWForm = ({ actionCreators, clearErrors, ...props }): React.ReactElement => {
	return (
		<>
			<Form {...props} />
			<ClearErrors actionCreators={actionCreators} />
		</>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	clearErrors: (actionCreators) => dispatch(actionCreators.clearErrors()),
});
export default withRouter<any, any>(connect(() => {}, mapDispatchToProps)(OWForm));
